var exports = {
  "X7": "UserProfileBadges.module__containerModal___V3hCal",
  "j4": "UserProfileBadges.module__containerModalMobile___V3hCal",
  "pP": "UserProfileBadges.module__containerModalDesktop___V3hCal",
  "RS": "UserProfileBadges.module__containerPopout___V3hCal",
  "Qk": "UserProfileBadges.module__badgeMobile___V3hCal",
  "EJ": "UserProfileBadges.module__badgeDesktop___V3hCal",
  "X8": "UserProfileBadges.module__sequenceBadge___V3hCal",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___V3hCal",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___V3hCal",
  "nf": "UserProfileBadges.module__link___V3hCal",
  "$J": "UserProfileBadges.module__linkButton___V3hCal",
  "tt": "UserProfileBadges.module__hoverCard___V3hCal",
  "I": "UserProfileBadges.module__hoverCardIcon___V3hCal",
  "Z3": "UserProfileBadges.module__hoverCardTitle___V3hCal",
  "Ox": "UserProfileBadges.module__hoverCardDetail___V3hCal",
  "SD": "UserProfileBadges.module__hoverCardSequence___V3hCal",
};

module.exports = exports;
